import React from "react";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import defaultImg from '../../../../../assets/img/bioimg.png'

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const reportData = this.props.data;

        function isValidBase64Image(base64String) {
            return base64String.startsWith('data:image/');
        }
        return (
            <div>
                <h3><center><u>Employee Biometric Details Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Estate: </b> {searchData.estate}</div>
                    <div className="col"><b>Division: </b> {searchData.division == undefined ? "All Divisions" : searchData.division}</div>
                </div>
                <TableContainer component={Paper}>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>Registration Number</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>Employee Name</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>Biometric Data</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>Employee Type</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>Status</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {reportData.map((row, i) => (
                                <TableRow key={i}>
                                    <TableCell component="th" scope="row" align="center"> {row.registrationNumber}</TableCell>
                                    <TableCell component="th" scope="row" align="center"> {row.employeeName}</TableCell>
                                    <TableCell align="center">
                                        {isValidBase64Image(row.convertedEmployeeBiometricData) ? (
                                            <img
                                                src={row.convertedEmployeeBiometricData}
                                                alt={`${row.employeeName}'s biometric image`}
                                                style={{ width: 100, height: 100 }}
                                            />
                                        ) : (
                                            <img
                                                src={defaultImg}
                                                alt="Default placeholder"
                                                style={{ width: 100, height: 100 }}
                                            />
                                        )}
                                    </TableCell>
                                    <TableCell component="th" scope="row" align="center"> {row.employeeType}</TableCell>
                                    <TableCell component="th" scope="row" align="center"> {row.isActive}</TableCell>
                                </TableRow>
                            )
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        );
    }
}